function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.46 283.46"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.464 70.867h-70.87v-21.26h-14.167c-23.45 0-42.52 19.073-42.52 42.523v162.987h42.52v28.348H85.037v-28.348h42.523V92.13c0-23.45-19.07-42.523-42.52-42.523H70.867v21.26H-.001V21.26h85.04c23.16 0 43.757 11.16 56.697 28.39 12.93-17.23 33.53-28.39 56.69-28.39h85.039l-.001 49.607z",
  id: "Streetlight"
})));